module.exports = __webpack_public_path__ + "static/media/couple.4e3086f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/register/couple.jpg
// module id = 586
// module chunks = 0